import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  switchUsbLoading: {},
};

const usbLoadingSlice = createSlice({
  name: "usbLoading",
  initialState,
  reducers: {
    setSwitchUsbLoading: (state, action) => {
      state.switchUsbLoading = action.payload;
    },
    updateDeviceLoading: (state, action) => {
      const { deviceId, isLoading } = action.payload;
      state.switchUsbLoading[deviceId] = isLoading;
    },
    resetSwitchUsbLoading: (state) => {
      state.switchUsbLoading = {};
    },
  },
});
export const {
  setSwitchUsbLoading,
  updateDeviceLoading,
  resetSwitchUsbLoading,
} = usbLoadingSlice.actions;

export default usbLoadingSlice.reducer;
